import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SkuRankingHelper } from 'src/app/components/pages/sku-ranking/sku-ranking-helper';
import { FiltersHelper } from 'src/app/components/elements/add-more-filter-ranking/filters-helper';
import { FILTER_CONFIGS_RANKING, SkuRankingQueries } from 'src/app/model/constants';
import { CsvService } from 'src/app/services/csv.services';
import { FilterHelper } from 'src/app/components/elements/add-more-filter/filter-helper';
import { UserService } from 'src/app/services/user.services';

@Component({
  selector: 'app-sku-ranking-vs-ly-ranking',
  templateUrl: './vs-ly-ranking.component.html',
  styleUrls: ['./vs-ly-ranking.component.scss']
})

export class SkuRankingVsLyRankingComponent implements OnInit {
  @Input() listData_Filter?: any;
  @Input() selectedDateType?: string;
  @Input() selectedSalesDate?: string[];
  @ViewChild('downloadLink') downloadLink: ElementRef;
  public isLoading: boolean = false;
  public isLoadingTimeline: boolean = false;
  readonly filterModuleName: string = 'sku-ranking';
  lstOption_Selected: any = {};
  lstOption_IsUsed: any = {};
  lstOption_States: any = {};
  FILTERS: any = FILTER_CONFIGS_RANKING?.ADD_MORE_FILTER?.COMMONS?.KEY_NAME || [];
  SKU_RANKING_FILTERS = FILTER_CONFIGS_RANKING?.ADD_MORE_FILTER?.SKU_RANKING?.COLLECTIONS1;
  defaultVisibleFilters: number = FILTER_CONFIGS_RANKING?.ADD_MORE_FILTER?.SKU_RANKING?.VISIBLE_COUNT ?? 4;

  // Financial metrics data
  financialMetrics = {
    value: '¥0M',
    valueVsLy: '0%',
    valueVsLyClass: 'text-secondary',
    volume: '0K',
    volumeVsLy: '0%',
    volumeVsLyClass: 'text-secondary',
    price: '¥0',
    priceVsLy: '¥0',
    priceVsLyClass: 'text-secondary'
  };

  skuRankingData: any = [];
  skuRankingTimelineData: any = [];

  skuFilterQuery: object = {};
  skuFilterQueryTimeline: object = {};
  skuRowClick: object = [];
  isLoadingTimelineData: boolean = false;
  isShowChard: boolean = false;
  selectedItem: any | null = null;
  selectedItems: any[] = [];
  selectedItemsApply: any[] = [];
  selectedMaker: string | null = null;
  loadingSeconds = 0;
  constructor(private http: HttpClient, private filtersHelper: FiltersHelper, private csvService: CsvService, private userService: UserService) { }

  ngOnInit() {
    const lstOption = FilterHelper.init_lstOption_States(`${this.filterModuleName}_${this.userService.getUserFilterName()}`, this.FILTERS, this.defaultVisibleFilters, this.userService.getUserInfo()) || {};
    this.lstOption_States = { ...lstOption?.lstOption_States };
    this.lstOption_Selected = { ...lstOption?.lstOption_Selected };
    this.listData_Filter = { ...lstOption.listData_Filter };
    this.lstOption_IsUsed = FilterHelper.getListIsUsedFilter(this.FILTERS, this.SKU_RANKING_FILTERS) || {};
    this.onSearchData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['lstOption_Selected']) {
      this.onSearchData();
    }

    if (changes['selectedDateType'] || changes['selectedSalesDate']) {
      if (this.selectedDateType && this.selectedSalesDate) {
        this.isShowChard = false;
        this.onSearchData();
      }
    }
  }

  onSalesDateModelChange(event: any) {
    this.onSearchData();
  }
  formatValue = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    return `${value.toLocaleString('en-US')}`;
  };

  formatVolume = (volume: number | null | undefined): string => {
    if (volume == null || isNaN(volume)) return "";
    return `${volume.toLocaleString('en-US')}`;
  };

  formatPrice = (price: number | null | undefined): string => {
    if (price == null || isNaN(price)) return "";
    return `${price.toLocaleString('en-US')}`;
  };
  formatPriceNoYen = (price: number | null | undefined): string => {
    if (price == null || isNaN(price)) return "";
    return `${price.toLocaleString('en-US')}`;
  };
  formatPercentage = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(1)}`;
  };
  formatNoPercentage = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    return `${value.toFixed(1)}`;
  };
  formatPercentageNo0 = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value}`;
  };
  formatPriceDiff = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    const sign = value >= 0 ? '+' : '-';
    return `${sign}${Math.abs(value).toLocaleString('en-US')}`;
  };
  formatPriceDiffNoSign = (value: number | null | undefined): string => {
    if (value == null || isNaN(value)) return "";
    const sign = value >= 0 ? '+' : '';
    return `${Math.abs(value).toLocaleString('en-US')}`;
  };
  updateFinancialMetrics(topScrollCard: any) {


    this.financialMetrics = {
      value: this.formatValue(topScrollCard.TOTAL_VALUE),
      valueVsLy: this.formatPercentage(topScrollCard.TOTAL_VALUE_VS_LY),
      valueVsLyClass: topScrollCard.TOTAL_VALUE_VS_LY >= 0 ? 'text-success' : 'text-danger',
      volume: this.formatVolume(topScrollCard.TOTAL_VOLUME_BOTTLE),
      volumeVsLy: this.formatPercentage(topScrollCard.TOTAL_VOLUME_BOTTLE_VS_LY),
      volumeVsLyClass: topScrollCard.TOTAL_VOLUME_BOTTLE_VS_LY >= 0 ? 'text-success' : 'text-danger',
      price: this.formatPrice(topScrollCard.TOTAL_PRICE_BOTTLE),
      priceVsLy: this.formatPriceDiff(topScrollCard.TOTAL_PRICE_BOTTLE_VS_LY),
      priceVsLyClass: topScrollCard.TOTAL_PRICE_BOTTLE_VS_LY >= 0 ? 'text-success' : 'text-danger'
    };
  }

  onUpdateChart(event: any) {
    const { lstOption_States, lstOption_Selected } = event;

    if (lstOption_States && lstOption_Selected) {
      this.lstOption_Selected = {};
      this.lstOption_Selected = lstOption_Selected;
      this.lstOption_States = {};
      this.lstOption_States = lstOption_States;
    }

    this.updateVsLyRankingData();
  }

  public updateVsLyRankingData(): void {
    this.onSearchData();
  }

  private loadingInterval: any;

  startLoading() {
    this.isLoading = true;
    this.loadingSeconds = 0;

    const tick = () => {
      if (!this.isLoading) return;
      this.loadingSeconds++;
      this.loadingInterval = setTimeout(tick, 1200);
    };

    this.loadingInterval = setTimeout(tick, 1200);
  }

  stopLoading() {
    this.isLoading = false;
    if (this.loadingInterval) {
      clearTimeout(this.loadingInterval);
      this.loadingInterval = null;
    }
  }
  onSearchData() {
     this.isLoading = true;
     this.startLoading()
    this.skuFilterQuery = SkuRankingHelper.SkuRankingVsLyRankingSetQueryString(this.lstOption_Selected);

    if (this.selectedDateType &&
      this.selectedSalesDate &&
      this.selectedSalesDate.length > 0 &&
      this.selectedDateType !== undefined &&
      this.selectedSalesDate !== undefined) {
      this.isShowChard = false;
      this.skuFilterQuery['PERIOD_TYPE'] = this.selectedDateType?.toUpperCase();
      this.skuFilterQuery['TARGET_PERIOD'] = this.selectedSalesDate;

      SkuRankingHelper.GetSkuRankingVsLyRankingData(this.http, this.skuFilterQuery).then((data) => {
        if (data && data.TOP_SCROLL_CARD) {
          this.updateFinancialMetrics(data.TOP_SCROLL_CARD);
          this.skuRankingData = data.ListAll;
        }
        this.selectedItem = null;
        this.selectedMaker = null;
        this.selectedItems = [];
        this.isLoading = false;
        this.stopLoading()
      });
    }
  }

  exportDetailRanking_CSV_by_Url() {
    this.skuFilterQuery = SkuRankingHelper.SkuRankingVsLyRankingSetQueryString(this.lstOption_Selected);

    if (this.selectedDateType &&
      this.selectedSalesDate &&
      this.selectedSalesDate.length > 0 &&
      this.selectedDateType !== undefined &&
      this.selectedSalesDate !== undefined) {
      const timelineQuery = this.selectedItemsApply.map(item => ({
      PRODUCT_NAME_EN: item?.SKU,
      MCI_MAIN_5_MAKER_ONE: item?.MAKER
    }))
      this.skuFilterQuery['Selected']['PERIOD_TYPE'] = this.selectedDateType?.toUpperCase();
      this.skuFilterQuery['Selected']['LIST_PRODUCT'] = timelineQuery;
      let cacheKey = SkuRankingHelper.getCacheKeyDetail(this.skuFilterQuery);
      this.skuFilterQuery['CacheKey'] = cacheKey;
      this.csvService.getCsvUrl(SkuRankingQueries.skuRankingVsLyRanking, this.skuFilterQuery, '')
        .subscribe((data) => {
          if (data) {
            this._downloadCsv(data?.Csv_Url);
          }
        });
    }
  }

  exportListRanking_CSV_by_Url() {
    this.skuFilterQuery = SkuRankingHelper.SkuRankingVsLyRankingSetQueryString(this.lstOption_Selected);

    if (this.selectedDateType &&
      this.selectedSalesDate &&
      this.selectedSalesDate.length > 0 &&
      this.selectedDateType !== undefined &&
      this.selectedSalesDate !== undefined) {
      this.skuFilterQuery['Selected']['PERIOD_TYPE'] = this.selectedDateType?.toUpperCase();
      this.skuFilterQuery['Selected']['TARGET_PERIOD'] = this.selectedSalesDate;
      let cacheKey = SkuRankingHelper.getCacheKey(this.skuFilterQuery);
      this.skuFilterQuery['CacheKey'] = cacheKey;
      this.csvService.getCsvUrl(SkuRankingQueries.skuRankingVsLyRanking, this.skuFilterQuery, '')
        .subscribe((data) => {
          if (data) {
            this._downloadCsv(data?.Csv_Url);
          }
        });
    }
  }

 onMakerClick(maker: string) {
  if (maker === 'ALL') {
      this.selectedMaker = null;
    } else {
      this.selectedItem = null;
      this.isShowChard = false;
      this.selectedMaker = maker;
    }
  }
  onRowClick(item: any) {


    if (this.selectedItem == null || this.selectedItem != item) {
      this.selectedItem = item;
      this.selectedMaker = null;
    } else {
      this.selectedItem = null;
      this.isShowChard = false;
      return
    }
    this.isLoadingTimelineData = true;
    this.startLoading()
    this.isShowChard = true;
    const timelineQuery = [{
      PRODUCT_NAME_EN: item?.SKU,
      MCI_MAIN_5_MAKER_ONE: item?.MAKER
    }]
    this.skuRowClick = [{
      PRODUCT_NAME_EN: item?.SKU,
      MCI_MAIN_5_MAKER_ONE: item?.MAKER
    }]
    this.skuFilterQuery['PERIOD_TYPE'] = this.selectedDateType?.toUpperCase();

    SkuRankingHelper.GetSkuRankingVsLyRankingTimelineData(this.http, this.skuFilterQuery, timelineQuery).then((data) => {
      this.skuRankingTimelineData = data.ListAll;
      this.isLoadingTimelineData = false;
      this.stopLoading()
    })
  }

  private _downloadCsv(fileUrl: any) {
    if (fileUrl && fileUrl.length > 0) {
      const link = this.downloadLink.nativeElement;
      link.href = fileUrl;
      link.download = '';
      link.click();
    }
  }

  sortColumn: string = '';
  sortReverse: boolean = false;

  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortReverse = !this.sortReverse;
    } else {
      this.sortColumn = column;
      this.sortReverse = false;
    }

    const japaneseRegex = /[\u3040-\u30ff\u4e00-\u9faf]/;

    this.skuRankingData.sort((a, b) => {
      let valA = a[column];
      let valB = b[column];


      if (typeof valA === "string" && typeof valB === "string") {
        const hasJaA = japaneseRegex.test(valA);
        const hasJaB = japaneseRegex.test(valB);


        if (hasJaA && !hasJaB) return 1;
        if (!hasJaA && hasJaB) return -1;


        const compare = valA.localeCompare(valB, "en", { sensitivity: "base" });
        return this.sortReverse ? -compare : compare;
      }


      if (typeof valA === "number" && typeof valB === "number") {
        return this.sortReverse ? valB - valA : valA - valB;
      }

      return 0;
    });
  }


  toggleSelection(item: any) {
    this.selectedItem=null;
    const index = this.selectedItems.indexOf(item);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
  }

  toggleSelectAll(event: any) {
     this.selectedItem=null;
    if (event.target.checked) {
      this.selectedItems = [...this.skuRankingData];
    } else {
      this.selectedItems = [];
    }
  }

  isAllSelected(): boolean {
    return this.skuRankingData.length > 0 && this.selectedItems.length === this.skuRankingData.length;
  }
  applySelection() {
    this.isLoadingTimelineData = true;
    this.startLoading()
    this.isShowChard = true;
    const timelineQuery = this.selectedItems.map(item => ({
      PRODUCT_NAME_EN: item?.SKU,
      MCI_MAIN_5_MAKER_ONE: item?.MAKER
    }))
    this.selectedItemsApply = this.selectedItems.map(item => ({
      SKU: item?.SKU,
      MAKER: item?.MAKER
    }))
    this.skuFilterQuery['PERIOD_TYPE'] = this.selectedDateType?.toUpperCase();

    SkuRankingHelper.GetSkuRankingVsLyRankingTimelineData(this.http, this.skuFilterQuery, timelineQuery).then((data) => {
      this.skuRankingTimelineData = data.ListAll;
      this.isLoadingTimelineData = false;
      this.stopLoading()
    })
  }
}